import type { Writable } from 'svelte/store';
import { writable } from 'svelte/store';
import {
    ALL_PLAYLISTS_ID,
    LIBRARY_LIST_PAGE_TO_TAB_ID,
    TAB_IDs,
    type TabId,
} from '../constants/tabs';
import type { FlowAction } from '~/jet/models';

// This store is okay to be global. It will never be used in SSR
export const currentTab: Writable<TabId | null> = writable(null);

export function getTabIdFromAction(action: FlowAction): TabId | null {
    const { $kind } = action.destination;

    switch ($kind) {
        case 'SearchPageIntent':
            return TAB_IDs.search;
        case 'HomePageIntent':
            return TAB_IDs.home;
        case 'BrowsePageIntent':
        case 'ArtistPageIntent':
            return TAB_IDs.browse;
        case 'LibraryListPageIntent':
            return LIBRARY_LIST_PAGE_TO_TAB_ID[action.destination.pageType];
        case 'LibraryPlaylistsIntent':
            return ALL_PLAYLISTS_ID;
        case 'PlaylistPageIntent':
            return { type: 'playlist', resourceId: action.destination.id };
        case 'AlbumPageIntent':
            return { type: 'album', resourceId: action.destination.id };
        case 'DetailPageIntent':
            return { type: action.destination.pageType };
    }

    if ($kind?.includes('Browse')) {
        return TAB_IDs.browse;
    }

    return null;
}
